import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { defaultTheme } from '../theme';
export const DefaultThemeProvider = (props) => {
    const { children, theme = defaultTheme, ...rest } = props;
    return (React.createElement(ChakraProvider, { theme: theme, ...rest }, children));
};
//# sourceMappingURL=DefaultThemeProvider.js.map